var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"notification-icon",attrs:{"title":"Показать уведомления","to":{ name: 'ClinicPanelNotificationList', query: { page: 1 } }}},[(_vm.newNotificationCount > 0)?_c('div',{staticClass:"notification-icon__new"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }